import React, { useEffect } from 'react';
import InfoIconComponent from '../../InfoIcon';
import style from './ExitTacticModules.module.css';
import PropTypes from 'prop-types';
import ValueListInput from '../../../../../../atomic/inputs/valueListInput/ValueListInput';

import NumberInputWithUnit from '../../../../../../atomic/inputs/numberInputWithUnit/NumberInputWithUnit';
import { useState } from 'react';
import CheckBox from '../../../../../../atomic/formElements/checkBox/CheckBox';
import NumberInputWithUnitDropdown from '../../../../../../atomic/inputs/numberInputWithUnitDropdown/NumberInputWIthUnitDropdown';
import CandleMagnitudeDocumentation from '../../../../documentation/CandleMagnitudeDocumentation';
import { colors } from '../../../../../../../colorVars';
const timeUnits = [
  {
    text: 'Min.',
    value: 'MINUTES',
  },
  {
    text: 'Day',
    value: 'DAYS',
  },
  {
    text: 'Week',
    value: 'WEEKS',
  },
  {
    text: 'Month',
    value: 'MONTHS',
  },
  {
    text: 'Quarter',
    value: 'QUARTERS',
  },
  {
    text: 'Year',
    value: 'YEARS',
  },
];

function CandleMagnitudeModule({ state }) {
  const [
    candleMagnitude,
    dispatchCandleMagnitude,
    ,
    setCandleMagnitudeEnabled,
  ] = state;

  const [candleDurationDisplay, setCandleDurationDisplay] = useState(0);
  const [numberOfPivotsDisplay, setNumberOfPivotsDisplay] = useState(0);
  const [candlesBackDisplay, setCandlesBackDisplay] = useState();
  const [atrCandleDurationDisplay, setAtrCandleDurationDisplay] = useState(0);
  const [
    pctOfAtrForFilterFirstMagDisplay,
    setPctOfAtrForFilterFirstMagDisplay,
  ] = useState(0);
  const [pctOfAtrForFilterAllMagDisplay, setPctOfAtrForFilterAllMagDisplay] =
    useState(0);
  const [pctAtrInsteadOfMag, setPctAtrInsteadOfMag] = useState(0);
  const [pctAtrGenerateAtrWhenNoPivots, setPctAtrGenerateAtrWhenNoPivots] = useState(100);
  const [pctAtrInitialStopDisplay, setPctAtrInitialStopDisplay] = useState(0);
  const [pctRetraceInitialStopDisplay, setPctRetraceInitialStopDisplay] =
    useState(0);
  const [pctAtrFirstTargetStopDisplay, setPctAtrFirstTargetStopDisplay] =
    useState(0);
  const [
    pctRetraceFirstTargetStopDisplay,
    setPctRetraceFirstTargetStopDisplay,
  ] = useState(0);

  useEffect(() => {
    setCandleMagnitudeEnabled(true);
  }, []);

  useEffect(() => {
    setCandleDurationDisplay(candleMagnitude.candleDuration ?? 0);
    setNumberOfPivotsDisplay(candleMagnitude.numberOfPivots ?? 0);
    setCandlesBackDisplay(candleMagnitude.ATR.candlesBack ?? 0);
    setAtrCandleDurationDisplay(candleMagnitude.ATR.candleDuration ?? 0);
    setPctOfAtrForFilterFirstMagDisplay(
      candleMagnitude.pctOfAtrForFilter * 100 ?? 0
    );
    setPctOfAtrForFilterAllMagDisplay(
      candleMagnitude.pctOfAtrForFilterAllMag * 100 ?? 0
    );
    setPctAtrInsteadOfMag(candleMagnitude.pctAtrInsteadOfMag * 100 ?? 0);
    setPctAtrGenerateAtrWhenNoPivots(candleMagnitude.pctAtrGenerateAtrWhenNoPivots * 100 ?? 100);
    setPctAtrInitialStopDisplay(candleMagnitude.pctAtrInitialStop * 100 ?? 0);
    setPctRetraceInitialStopDisplay(
      candleMagnitude.pctRetraceInitialStop * 100 ?? 0
    );
    setPctAtrFirstTargetStopDisplay(
      candleMagnitude.pctAtrFirstTargetStop * 100 ?? 0
    );
    setPctRetraceFirstTargetStopDisplay(
      candleMagnitude.pctRetraceFirstTargetStop * 100 ?? 0
    );
  }, [candleMagnitude]);

  return (
    <div className={style.moduleStyle}>
      <span className={style.tacticName}>
        <InfoIconComponent docs={CandleMagnitudeDocumentation} /> Candle
        Magnitude
      </span>

      <div className={style.inputs}>
        <div className={style.inputAndLabel}>
          <p>Candle Duration</p>
          <NumberInputWithUnitDropdown
            list={timeUnits}
            inputVal={candleDurationDisplay}
            setInputVal={setCandleDurationDisplay}
            selectVal={candleMagnitude.timeUnit}
            onBlur={(value) =>
              dispatchCandleMagnitude({ candleDuration: value })
            }
            setSelectVal={(value) =>
              dispatchCandleMagnitude({ timeUnit: value })
            }
          />
        </div>

        <div className={style.inputAndLabel}>
          <p>Pivots as Trails</p>
          <CheckBox
            checked={candleMagnitude.usePivotsAsTrails}
            onChange={(checked) =>
              dispatchCandleMagnitude({ usePivotsAsTrails: checked })
            }
          />
        </div>

        <div
          className={style.inputAndLabel}
          style={{ opacity: candleMagnitude.usePivotsAsTrails ? 1 : 0.5 }}
        >
          <p>Stop Placement</p>
          <select
            disabled={!candleMagnitude.usePivotsAsTrails}
            value={candleMagnitude.exitInPivotCandle}
            onChange={({ target }) =>
              dispatchCandleMagnitude({ exitInPivotCandle: target.value })
            }
          >
            <option value="high_low">High/Low</option>
            <option value="mid">Mid Point</option>
          </select>
        </div>
        <div
          className={style.inputAndLabel}
          style={{ opacity: candleMagnitude.usePivotsAsTrails ? 1 : 0.5 }}
        >
          <p># of Pivots</p>
          <NumberInputWithUnit
            disabled={!candleMagnitude.usePivotsAsTrails}
            direction="left"
            type="number"
            value={numberOfPivotsDisplay}
            setValue={setNumberOfPivotsDisplay}
            onBlur={(value) =>
              dispatchCandleMagnitude({ numberOfPivots: value })
            }
          >
            #
          </NumberInputWithUnit>
        </div>
        <div className={style.inputAndLabel}>
          <p style={{ fontSize: '10px' }}>No Inside Candles</p>
          <CheckBox
            checked={candleMagnitude.filterInsideCandleMagnitudes}
            onChange={(checked) =>
              dispatchCandleMagnitude({
                filterInsideCandleMagnitudes: checked,
              })
            }
          />
        </div>

        <div className={style.inputAndLabel}>
          <p>% per Pivot</p>
          <ValueListInput
            direction="right"
            percentageArray
            allowRepeats={true}
            currentValues={candleMagnitude.qtyPctPerPivot || []}
            symbol="%"
            onAddDelete={(valueList) =>
              dispatchCandleMagnitude({
                qtyPctPerPivot: valueList.map((item) => item / 100),
              })
            }
          />
        </div>

        <div className={style.inputAndLabel}>
          <p>Initial Stop</p>
          <select
            disabled={!candleMagnitude.usePivotsAsTrails}
            value={candleMagnitude.initialStop}
            onChange={({ target }) =>
              dispatchCandleMagnitude({ initialStop: target.value })
            }
          >
            <option value="NONE">None</option>
            <option value="ATR">ATR</option>
            <option value="CANDLE_RETRACE">Candle Retrace</option>
            <option value="CANDLE_HIGH_LOW">Candle High/Low</option>
          </select>
          {candleMagnitude.initialStop === 'ATR' ? (
            <NumberInputWithUnit
              disabled={!candleMagnitude.usePivotsAsTrails}
              direction="right"
              type="number"
              value={pctAtrInitialStopDisplay}
              setValue={setPctAtrInitialStopDisplay}
              onBlur={(value) =>
                dispatchCandleMagnitude({ pctAtrInitialStop: value / 100 })
              }
            >
              %
            </NumberInputWithUnit>
          ) : null}
          {candleMagnitude.initialStop === 'CANDLE_RETRACE' ? (
            <NumberInputWithUnit
              disabled={!candleMagnitude.usePivotsAsTrails}
              direction="right"
              type="number"
              value={pctRetraceInitialStopDisplay}
              setValue={setPctRetraceInitialStopDisplay}
              onBlur={(value) =>
                dispatchCandleMagnitude({ pctRetraceInitialStop: value / 100 })
              }
            >
              %
            </NumberInputWithUnit>
          ) : null}
        </div>
        {/*  */}
        <div className={style.inputAndLabel}>
          <p>1st Target Stop</p>
          <select
            disabled={!candleMagnitude.usePivotsAsTrails}
            value={candleMagnitude.firstTargetStop}
            onChange={({ target }) =>
              dispatchCandleMagnitude({ firstTargetStop: target.value })
            }
          >
            <option value="NONE">None</option>
            <option value="ATR">ATR</option>
            <option value="CANDLE_RETRACE">Candle Retrace</option>
            <option value="CANDLE_HIGH_LOW">Candle High/Low</option>
            <option value="BREAK_EVEN">Break Even</option>
          </select>
          {candleMagnitude.firstTargetStop === 'ATR' ? (
            <NumberInputWithUnit
              disabled={!candleMagnitude.usePivotsAsTrails}
              direction="right"
              type="number"
              value={pctAtrFirstTargetStopDisplay}
              setValue={setPctAtrFirstTargetStopDisplay}
              onBlur={(value) =>
                dispatchCandleMagnitude({ pctAtrFirstTargetStop: value / 100 })
              }
            >
              %
            </NumberInputWithUnit>
          ) : null}
          {candleMagnitude.firstTargetStop === 'CANDLE_RETRACE' ? (
            <NumberInputWithUnit
              disabled={!candleMagnitude.usePivotsAsTrails}
              direction="right"
              type="number"
              value={pctRetraceFirstTargetStopDisplay}
              setValue={setPctRetraceFirstTargetStopDisplay}
              onBlur={(value) =>
                dispatchCandleMagnitude({
                  pctRetraceFirstTargetStop: value / 100,
                })
              }
            >
              %
            </NumberInputWithUnit>
          ) : null}
        </div>

        <div className={style.greyBox}>
          <div className={style.inputAndLabel}>
            <p>Use ATR</p>
            <CheckBox
              checked={candleMagnitude.useAtr}
              onChange={(checked) =>
                dispatchCandleMagnitude({ useAtr: checked })
              }
            />
          </div>
          {candleMagnitude.useAtr ? (
            <>
              <div className={style.inputAndLabel}>
                <p>Candles Back</p>
                <NumberInputWithUnit
                  backgroundColor={colors.white}
                  direction="left"
                  type="number"
                  value={candlesBackDisplay}
                  setValue={setCandlesBackDisplay}
                  onBlur={(value) =>
                    dispatchCandleMagnitude({
                      ATR: {
                        ...candleMagnitude.ATR,
                        candlesBack: value,
                      },
                    })
                  }
                >
                  #
                </NumberInputWithUnit>
              </div>
              <div className={style.inputAndLabel}>
                <p>ATR Type</p>
                <select
                  value={candleMagnitude.ATR.atrType}
                  onChange={({ target }) =>
                    dispatchCandleMagnitude({
                      ATR: {
                        ...candleMagnitude.ATR,
                        atrType: target.value,
                      },
                    })
                  }
                >
                  <option value="WILDER">Wilder</option>
                  <option value="SMA">SMA</option>
                  <option value="SMA_NO_GAP">SMA No Gap</option>
                </select>
              </div>

              <div
                className={style.inputAndLabel}
                style={{ gridColumn: 'span 2' }}
              >
                <p>ATR Candle Duration</p>
                <NumberInputWithUnitDropdown
                  list={timeUnits}
                  inputVal={atrCandleDurationDisplay}
                  setInputVal={setAtrCandleDurationDisplay}
                  selectVal={candleMagnitude.ATR.timeUnit}
                  onBlur={(value) =>
                    dispatchCandleMagnitude({
                      ATR: {
                        ...candleMagnitude.ATR,
                        candleDuration: value,
                      },
                    })
                  }
                  setSelectVal={(value) =>
                    dispatchCandleMagnitude({
                      ATR: {
                        ...candleMagnitude.ATR,
                        timeUnit: value,
                      },
                    })
                  }
                />
              </div>
              <div
                className={style.inputAndLabel}
                style={{ gridColumn: 'span 1' }}
              >
                <p>Filter 1st Mag.</p>
                <CheckBox
                  margin="0 0 1px 0"
                  checked={candleMagnitude.filterFirstMagnitudeBasedOnAtr}
                  onChange={(checked) =>
                    dispatchCandleMagnitude({
                      filterFirstMagnitudeBasedOnAtr: checked,
                    })
                  }
                />
                <NumberInputWithUnit
                  backgroundColor={colors.white}
                  disabled={!candleMagnitude.filterFirstMagnitudeBasedOnAtr}
                  direction="right"
                  type="number"
                  value={pctOfAtrForFilterFirstMagDisplay}
                  setValue={setPctOfAtrForFilterFirstMagDisplay}
                  onBlur={(value) =>
                    dispatchCandleMagnitude({ pctOfAtrForFilter: value / 100 })
                  }
                >
                  %
                </NumberInputWithUnit>
              </div>
              <div
                className={style.inputAndLabel}
                style={{ gridColumn: 'span 1' }}
              >
                <p>Filter All Mag.</p>
                <CheckBox
                  margin="0 0 1px 0"
                  checked={candleMagnitude.filterAllMagnitudeBasedOnAtr}
                  onChange={(checked) =>
                    dispatchCandleMagnitude({
                      filterAllMagnitudeBasedOnAtr: checked,
                    })
                  }
                />
                <NumberInputWithUnit
                  backgroundColor={colors.white}
                  disabled={!candleMagnitude.filterAllMagnitudeBasedOnAtr}
                  direction="right"
                  type="number"
                  value={pctOfAtrForFilterAllMagDisplay}
                  setValue={setPctOfAtrForFilterAllMagDisplay}
                  onBlur={(value) =>
                    dispatchCandleMagnitude({
                      pctOfAtrForFilterAllMag: value / 100,
                    })
                  }
                >
                  %
                </NumberInputWithUnit>
              </div>
              <div
                className={style.inputAndLabel}
                style={{ gridColumn: 'span 1' }}
              >
                <p>% of ATR as Mag</p>
                <CheckBox
                  margin="0 0 1px 0"
                  checked={candleMagnitude.useAtrInsteadOfMag}
                  onChange={(checked) =>
                    dispatchCandleMagnitude({
                      useAtrInsteadOfMag: checked,
                    })
                  }
                />
                <NumberInputWithUnit
                  backgroundColor={colors.white}
                  disabled={!candleMagnitude.useAtrInsteadOfMag}
                  direction="right"
                  type="number"
                  value={pctAtrInsteadOfMag}
                  setValue={setPctAtrInsteadOfMag}
                  onBlur={(value) =>
                    dispatchCandleMagnitude({
                      pctAtrInsteadOfMag: value / 100,
                    })
                  }
                >
                  %
                </NumberInputWithUnit>
              </div>
              <div
                className={style.inputAndLabel}
                style={{ gridColumn: 'span 1' }}
              >
                <p>Extend Pivots w/ATR</p>
                <CheckBox
                  margin="0 0 1px 0"
                  checked={candleMagnitude.generateFromAtrWhenNoPivots}
                  onChange={(checked) =>
                    dispatchCandleMagnitude({
                      generateFromAtrWhenNoPivots: checked,
                    })
                  }
                />
                <NumberInputWithUnit
                  backgroundColor={colors.white}
                  disabled={!candleMagnitude.generateFromAtrWhenNoPivots}
                  direction="right"
                  type="number"
                  value={pctAtrGenerateAtrWhenNoPivots}
                  setValue={setPctAtrGenerateAtrWhenNoPivots}
                  onBlur={(value) =>
                    dispatchCandleMagnitude({
                      pctAtrGenerateAtrWhenNoPivots: value / 100,
                    })
                  }
                >
                  %
                </NumberInputWithUnit>
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}
CandleMagnitudeModule.propTypes = {
  state: PropTypes.array.isRequired,
};
export default CandleMagnitudeModule;
